
const EnableAutoTab=(item,tabIndex)=>{    
    //console.log('Auto Tab inner text-'+item.val()+' input length- '+item.val().length+' maxlen- '+item.attr('maxlength'));

    if(item.val().length == item.attr('maxlength')) {
        console.log('false');
      if(tabIndex===0){
          if(item.parent().next('.number-input').length)  {
         item.parent().next('.number-input').children('input').focus();
       }
     }
     else{
      if(item.parent().next().next('.number-input').length)  {
        item.parent().next().next('.number-input').children('input').focus();
      } 
        else if(item.parent().next().next().next('.number-input').length)  {
        item.parent().next().next().next('.number-input').children('input').focus();
      } 
       else if(item.parent().next().next().next().next('.number-input').length)  {
        item.parent().next().next().next().next('.number-input').children('input').focus();
      } 
       else if(item.parent().next().next().next().next().next('.number-input').length)  {
        item.parent().next().next().next().next().next('.number-input').children('input').focus();
      }
     }
 }
}

module.exports = EnableAutoTab;


// WEBPACK FOOTER //
// ./shared/scripts/EnableAutoTab.js